import InventoryItem from "./InventoryItem";

export default InventoryItem;
export { InventoryItem };
